import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosClient, {
  getData,
  postData,
  getBaseUrl,
} from "../global/Globalapi";
import CancelOrderModal from "../Components/CancelOrderModal";
import ReturnOrderModal from "../Components/ReturnOrderModal";
import LoginModal from "../Components/Account/LoginModal.jsx";
// import { FiShare2 } from "react-icons/fi";
import { FiShare2, FiMail } from "react-icons/fi";
import { IoArrowBackOutline } from "react-icons/io5";
import { FaWhatsapp } from "react-icons/fa";
const baseURL = axiosClient.defaults.baseURL;
// SVG placeholder as data URI - works offline, no external dependencies
const PLACEHOLDER_IMAGE =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='128' height='128' viewBox='0 0 128 128'%3E%3Crect width='128' height='128' fill='%23f3f4f6'/%3E%3Cpath d='M64 40c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zm0 26c-5.514 0-10-4.486-10-10s4.486-10 10-10 10 4.486 10 10-4.486 10-10 10z' fill='%239ca3af'/%3E%3Cpath d='M96 88H32l16-24 12 12 16-20 20 32z' fill='%239ca3af'/%3E%3Ctext x='50%25' y='95%25' font-family='Arial, sans-serif' font-size='10' fill='%236b7280' text-anchor='middle'%3ENo Image%3C/text%3E%3C/svg%3E";

// Component to handle product images
const ProductImage = ({ productId, alt, className, onError }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchImage = async () => {
      if (!productId) {
        setLoading(false);
        setError(true);
        return;
      }

      try {
        const response = await getData(`/product_images/${productId}`);
        console.log("Product images fetched:", response.data);
        if (response.data && response.data.length > 0) {
          const firstImage =
            response.data.find((img) => img.display_order === 1) ||
            response.data[0];
          setImageUrl(`${baseURL}/uploads/${firstImage.file_name}`);
          console.log("Product image fetched:", firstImage);
          // setImageUrl(firstImage.file_name);
          setError(false);
        } else {
          setError(true);
        }
      } catch (error) {
        console.error("Error fetching product image:", error);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchImage();
  }, [productId]);

  const handleImageError = (e) => {
    console.error("Image failed to load:", imageUrl);
    setError(true);
    e.target.src = PLACEHOLDER_IMAGE; // Use data URI placeholder
    if (onError) onError(e);
  };

  if (loading) {
    return (
      <div
        className={`${className} bg-gray-200 animate-pulse flex items-center justify-center`}
      >
        <svg
          className="w-8 h-8 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
      </div>
    );
  }

  if (error || !imageUrl) {
    return (
      <img
        src={PLACEHOLDER_IMAGE}
        alt={alt || "Product image"}
        className={className}
      />
    );
  }

  return (
    <img
      src={imageUrl}
      alt={alt || "Product image"}
      className={className}
      onError={handleImageError}
      loading="lazy"
    />
  );
};

// Component to handle product names
const ProductName = ({ productId, fallback }) => {
  const [productName, setProductName] = useState(fallback || "Loading...");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProductName = async () => {
      if (!productId) {
        setProductName(fallback || "Unknown Product");
        setLoading(false);
        return;
      }

      try {
        const response = await getData(`/product/${productId}`);
        if (response.data) {
          const name =
            response.data.combo ||
            response.data.product_name ||
            "Unknown Product";
          setProductName(name);
        }
        console.log("Product name fetched:", response.data);
      } catch (error) {
        console.error("Error fetching product name:", error);
        setProductName(fallback || "Unknown Product");
      } finally {
        setLoading(false);
      }
    };

    fetchProductName();
  }, [productId, fallback]);

  if (loading) {
    return <span className="animate-pulse">Loading...</span>;
  }

  return <span>{productName}</span>;
};

// A small component to display status with colors
// const StatusBadge = ({ status }) => {
//   const statusConfig = {
//     Pending: {
//       classes:
//         "bg-gradient-to-r from-yellow-100 to-yellow-200 text-yellow-800 border-yellow-300",
//       icon: "⏳",
//     },
//     Shipped: {
//       classes:
//         "bg-gradient-to-r from-blue-100 to-blue-200 text-blue-800 border-blue-300",
//       icon: "🚚",
//     },
//     Delivered: {
//       classes:
//         "bg-gradient-to-r from-green-100 to-green-200 text-green-800 border-green-300",
//       icon: "✅",
//     },
//     Cancelled: {
//       classes:
//         "bg-gradient-to-r from-red-100 to-red-200 text-red-800 border-red-300",
//       icon: "❌",
//     },
//     Processing: {
//       classes:
//         "bg-gradient-to-r from-purple-100 to-purple-200 text-purple-800 border-purple-300",
//       icon: "⚙️",
//     },
//     "Return Initiated": {
//       classes:
//         "bg-gradient-to-r from-orange-100 to-orange-200 text-orange-800 border-orange-300",
//       icon: "🔄",
//     },
//     Returned: {
//       classes:
//         "bg-gradient-to-r from-teal-100 to-teal-200 text-teal-800 border-teal-300",
//       icon: "↩️",
//     },
//     Success: {
//       classes:
//         "bg-gradient-to-r from-emerald-100 to-emerald-200 text-emerald-800 border-emerald-300",
//       icon: "🎉",
//     },
//     Ordered: {
//       classes:
//         "bg-gradient-to-r from-indigo-100 to-indigo-200 text-indigo-800 border-indigo-300",
//       icon: "📦",
//     },
//   };

//   const config = statusConfig[status] || {
//     classes:
//       "bg-gradient-to-r from-gray-100 to-gray-200 text-gray-800 border-gray-300",
//     icon: "❓",
//   };

//   return (
//     <span
//       className={`inline-flex items-center px-4 py-2 text-sm font-semibold rounded-full border-2 shadow-sm ${config.classes}`}
//     >
//       <span className="mr-2 text-base">{config.icon}</span>
//       {status}
//     </span>
//   );
// };
const StatusBadge = ({ status }) => {
  const statusConfig = {
    Pending: {
      label: "Payment Pending",
      classes:
        "bg-gradient-to-r from-yellow-100 to-yellow-200 text-yellow-800 border-yellow-300",
      icon: "💰",
    },
    Processing: {
      label: "Payment Pending",
      classes:
        "bg-gradient-to-r from-yellow-100 to-yellow-200 text-yellow-800 border-yellow-300",
      icon: "💰",
    },
    Shipped: {
      label: "Shipped",
      classes:
        "bg-gradient-to-r from-blue-100 to-blue-200 text-blue-800 border-blue-300",
      icon: "🚚",
    },
    Delivered: {
      label: "Delivered",
      classes:
        "bg-gradient-to-r from-green-100 to-green-200 text-green-800 border-green-300",
      icon: "✅",
    },
    Cancelled: {
      label: "Cancelled",
      classes:
        "bg-gradient-to-r from-red-100 to-red-200 text-red-800 border-red-300",
      icon: "❌",
    },
    "Return Initiated": {
      label: "Return Initiated",
      classes:
        "bg-gradient-to-r from-orange-100 to-orange-200 text-orange-800 border-orange-300",
      icon: "🔄",
    },
    Returned: {
      label: "Returned",
      classes:
        "bg-gradient-to-r from-teal-100 to-teal-200 text-teal-800 border-teal-300",
      icon: "↩️",
    },
    Ordered: {
      label: "Order Placed",
      classes:
        "bg-gradient-to-r from-indigo-100 to-indigo-200 text-indigo-800 border-indigo-300",
      icon: "📦",
    },
    Success: {
      label: "Success",
      classes:
        "bg-gradient-to-r from-emerald-100 to-emerald-200 text-emerald-800 border-emerald-300",
      icon: "🎉",
    },
  };

  const config = statusConfig[status] || {
    label: status,
    classes:
      "bg-gradient-to-r from-gray-100 to-gray-200 text-gray-800 border-gray-300",
    icon: "❓",
  };

  return (
    <span
      className={`inline-flex items-center px-4 py-2 text-sm font-semibold rounded-full border-2 shadow-sm ${config.classes}`}
    >
      <span className="mr-2 text-base">{config.icon}</span>
      {config.label}
    </span>
  );
};

const MyOrders = () => {
  const isPaymentPending = (status) =>
    status === "Pending" || status === "Processing";

  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [loginOpen, setLoginOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(() => {
    const s = localStorage.getItem("user");
    return s ? JSON.parse(s) : null;
  });
  // const formatDate = (date) =>
  //   date
  //     ? new Date(date).toLocaleString("en-IN", {
  //         day: "2-digit",
  //         month: "short",
  //         year: "numeric",
  //         hour: "2-digit",
  //         minute: "2-digit",
  //         hour12: true,
  //       })
  //     : "-";
  // const formatDate = (date) =>
  //   date
  //     ? new Date(date).toLocaleString("en-IN", {
  //         // timeZone: "Asia/Kolkata", // 🔥 THIS IS THE FIX
  //         day: "2-digit",
  //         month: "short",
  //         year: "numeric",
  //         hour: "2-digit",
  //         minute: "2-digit",
  //         hour12: true,
  //       })
  //     : "-";
  // const formatDate = (date) => {
  //   if (!date) return "-";

  //   const d = new Date(date);

  //   if (isNaN(d.getTime())) return "-";

  //   return d.toLocaleString("en-IN", {
  //     timeZone: "Asia/Kolkata",
  //     day: "2-digit",
  //     month: "short",
  //     year: "numeric",
  //     hour: "2-digit",
  //     minute: "2-digit",
  //     hour12: true,
  //   });
  // };
  const formatDate = (date) => {
    if (!date) return "-";

    const d = new Date(date);
    if (isNaN(d.getTime())) return "-";

  return d.toLocaleString("en-IN", {
    //  timeZone: "Asia/Kolkata", // ✅ For Local Testing
    timeZone: "UTC", // ✅ For Live
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

  // Cancel order modal
  const [cancelModalOpen, setCancelModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  // Return order modal
  const [returnModalOpen, setReturnModalOpen] = useState(false);
  const [selectedReturnOrder, setSelectedReturnOrder] = useState(null);
  const userId = currentUser?.user_id;
  const [shareOrder, setShareOrder] = useState(null);

  const fetchOrders = async () => {
    if (!userId) {
      setLoginOpen(true);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await getData(`/orders/user/${userId}`);
      console.log("Raw order data:", response);

      if (!response || !response.data) {
        throw new Error("No data received from server");
      }

      // Debug: Log each order's structure
      response.data.forEach((order, index) => {
        console.log(`Order ${index}:`, {
          order_id: order.order_id,
          product_id: order.product_id,
          total: order.total,
          status: order.status,
        });
      });

      // Use the original order structure and add items with actual product IDs
      // const ordersWithItems = response.data.map((order, index) => ({
      //   ...order,
      //   items: [
      //     {
      //       product_id: order.product_id || (index + 1),
      //       combo: "Loading...",
      //       quantity: order.quantity,
      //       amount: order.amount || order.total
      //     }
      //   ]
      // }));
      const ordersWithItems = response.data.map((order) => ({
        ...order,
        items: order.products.map((p) => ({
          product_id: p.product_id,
          quantity: p.quantity,
          amount: p.amount,
        })),
      }));

      console.log("Orders with items:", ordersWithItems);
      setOrders(ordersWithItems);

      // Store orders in localStorage for tracking page (optional)
      try {
        localStorage.setItem("orders", JSON.stringify(ordersWithItems));
      } catch (e) {
        console.error("Failed to store orders in localStorage:", e);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      setError(
        `Failed to load your orders: ${error.message || "Please try again later."}`,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [userId]);

  // When login modal sets a user, refresh orders
  useEffect(() => {
    if (currentUser && currentUser.id) {
      fetchOrders();
    }
  }, [currentUser]);

  // === Cancel Order ===
  const openCancelModal = (orderId) => {
    setSelectedOrder(orderId);
    setCancelModalOpen(true);
  };

  const handleCancelOrder = async (reason) => {
    if (!selectedOrder || !reason) return;
    try {
      const payload = { orderId: selectedOrder, userId: userId, reason };
      const response = await postData("/orders/cancel", payload);
      alert(response.data.message || "Order cancelled successfully");
      fetchOrders();
    } catch (err) {
      console.error("Cancel order failed:", err);
      alert(err.response?.data?.message || "Failed to cancel the order.");
    } finally {
      setCancelModalOpen(false);
      setSelectedOrder(null);
    }
  };
  const handleShareOrder = (order) => {
    const shareData = {
      title: "My Order Details",
      text: `Order #${order.order_id}\nStatus: ${order.status}\nTotal: ₹${Number(order.total || 0).toFixed(2)}`,
      url: `${window.location.origin}/order-tracking/${order.order_id}`,
    };

    if (navigator.share) {
      navigator.share(shareData).catch((err) => {
        console.error("Share failed:", err);
      });
    } else {
      // Fallback for desktop
      navigator.clipboard.writeText(`${shareData.text}\n${shareData.url}`);
      alert("Order details copied to clipboard!");
    }
  };
  const SHARE_WHATSAPP = "917904168568"; // <-- your WhatsApp number
  const SHARE_EMAILS = "malarsbakers@gmail.com";
  const handleBack = () => {
    navigate(-1); // goes to previous page
  };
  const getShareText = (order) =>
    `Order #${order.order_id}
Status: ${order.status}
Total: ₹${Number(order.total || 0).toFixed(2)}
Track: ${window.location.origin}/order-tracking/${order.order_id}`;

  // === Return Order ===
  const openReturnModal = (orderId) => {
    setSelectedReturnOrder(orderId);
    setReturnModalOpen(true);
  };

  const handleReturnOrder = async (reason) => {
    if (!selectedReturnOrder || !reason) return;
    try {
      const payload = { orderId: selectedReturnOrder, userId: userId, reason };
      const response = await postData("/orders/return", payload);
      alert(response.data.message || "Return process initiated");
      fetchOrders();
    } catch (err) {
      console.error("Return order failed:", err);
      alert(err.response?.data?.message || "Failed to return the order.");
    } finally {
      setReturnModalOpen(false);
      setSelectedReturnOrder(null);
    }
  };

  // === UI Rendering ===
  if (loading)
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mb-4"></div>
          <h3 className="text-xl font-semibold text-gray-700 mb-2">
            Loading your orders...
          </h3>
          <p className="text-gray-500">
            Please wait while we fetch your order details
          </p>
        </div>
      </div>
    );

  if (error && !loginOpen)
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center">
        <div className="text-center max-w-md mx-auto">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg
              className="w-10 h-10 text-red-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            Oops! Something went wrong
          </h3>
          <p className="text-gray-600 mb-6">{error}</p>
          <button
            onClick={fetchOrders}
            className="bg-gradient-to-r from-red-600 to-red-700 text-white px-6 py-3 rounded-lg font-semibold hover:from-red-700 hover:to-red-800 transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            Try Again
          </button>
        </div>
      </div>
    );

  // Render login modal if not logged in
  if (!userId) {
    return (
      <div className="min-h-screen bg-gray-100">
        <LoginModal
          isModalOpen={loginOpen}
          setIsModalOpen={setLoginOpen}
          setSignUp={() => {}}
          setUser={setCurrentUser}
          type="guest"
        />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header Section - Amazon Style */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <button
              onClick={handleBack}
              className="mb-4 bg-[#c97c5d] hover:bg-orange-600 text-white font-semibold px-4 py-2 rounded-lg hidden md:inline-flex"
            >
              <IoArrowBackOutline className="text-2xl" />
            </button>

            <div>
              <h1 className="text-3xl font-bold text-gray-900">Your Orders</h1>
              <p className="text-gray-600 mt-1 text-sm">
                Track, return, or buy things again
              </p>
            </div>
            <div className="hidden sm:flex items-center space-x-4">
              <div className="bg-orange-100 text-orange-800 px-3 py-1 rounded text-sm font-medium">
                {orders.length} Order{orders.length !== 1 ? "s" : ""}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {orders.length === 0 ? (
          <div className="text-center py-16 bg-white rounded-lg">
            <div className="mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-6">
              <svg
                className="w-12 h-12 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                />
              </svg>
            </div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-2">
              No Orders Yet
            </h3>
            <p className="text-gray-600 mb-8 max-w-md mx-auto">
              You haven't placed any orders yet. Start shopping to see your
              orders here!
            </p>
            <button
              onClick={() => navigate("/")}
              className="bg-orange-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-orange-600 transition-all duration-200 shadow-lg hover:shadow-xl"
            >
              Start Shopping
            </button>
          </div>
        ) : (
          <div className="space-y-4">
            {orders.map((order, index) => {
              // ✅ Get product amount
              const productAmount =  order.products.reduce(
                (sum, item) => sum + Number(item.amount),
                0
              );
              console.log(productAmount, "productaaaaaaaaaaaaaaaaaaaaaaaaa");

              // ✅ Get total paid amount
              const totalAmount = Number(order.payedamount || order.total || 0);
              console.log(totalAmount, "totalttttttttttttttttttt");

              // ✅ Calculate delivery charge
              const deliveryCharge = totalAmount - productAmount;
              console.log(deliveryCharge, "deliveryyyyyyyyyyyyyyyyyyyyyyy");

              // ✅ Extract delivery type from address
              const addressText = (order.address || "").toUpperCase();

              let deliveryType = addressText.includes("HOMEDELIVERY")
                ? "Home Delivery"
                : addressText.includes("SAFEDELIVERY")
                  ? "Safe Delivery"
                  : "Takeaway";
              console.log(`Order ${index}:`, order);
              return (
                <div
                  key={`order_${order.order_id}_${index}`}
                  className="bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200 overflow-hidden border border-gray-200"
                >
                  {/* Order Header - Amazon Style */}
                  <div className="px-4 py-4 border-b border-gray-200">
                    <div className="flex flex-col sm:flex-row justify-between sm:items-center">
                      <div>
                        {/* <h2 className="text-lg font-bold text-gray-900">
                        {order.items && order.items.length > 0 ? (
                          <ProductName 
                            productId={order.items[0].product_id} 
                            fallback={`Order #${order.order_id}`}
                          />
                        ) : (
                          `Order #${order.order_id}`
                        )}
                      </h2> */}
                        <p className="text-sm text-gray-500 mt-1">
                          Ordered ID: {order.order_id}
                        </p>
                        <p className="text-sm text-gray-500 mt-1">
                          {order.items
                            ? `${order.items.length} item${order.items.length !== 1 ? "s" : ""}`
                            : "No items"}
                        </p>
                      </div>
                      {/* <div className="mt-2 sm:mt-0 sm:text-right">
                        <p className="text-sm text-gray-500">
                          Ordered on{" "}
                          {new Date(order.date).toLocaleString("en-IN", {
                            timeZone: "Asia/Kolkata",
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                            hour: "numeric",
                            minute: "2-digit",
                            hour12: true,
                          })}
                        </p>
                      </div> */}
                      <div className="mt-2 sm:mt-0 sm:text-right">
                        {/* ORDER DATE */}
                        <p className="text-sm text-gray-500">
                          {/* Ordered on{order.date} */}
                          Ordered on {formatDate(order.date)}
                          {/* {new Date(order.date).toLocaleString("en-IN", {
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                            hour: "numeric",
                            minute: "2-digit",
                            hour12: true,
                          })} */}
                        </p>

                        {/* CANCELLED DATE */}
                        {/* {order.status === "Cancelled" && order.cancelled_at && (
                          <p className="mt-1 text-sm text-red-600 font-medium">
                            Cancelled on{" "}
                            {order.cancelled_at &&
                              new Date(order.cancelled_at).toLocaleString("en-IN", {
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                                hour: "numeric",
                                minute: "2-digit",
                                hour12: true,
                              })}

                          </p>
                        )} */}
                        {/* CANCELLED DATE */}
                        {order.status === "Cancelled" && order.cancelled_at && (
                          <p className="mt-1 text-sm text-red-600 font-medium">
                            {/* Cancelled on{order.cancelled_at} */}
                            Cancelled on {formatDate(order.cancelled_at)}
                            {/* {
                              new Date(order.cancelled_at).toLocaleString("en-IN", {
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                                hour: "numeric",
                                minute: "2-digit",
                                hour12: true,
                              })} */}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Order Content - Amazon Style */}
                  <div className="px-4 py-3">
                    {/* Product Items */}
                    {order.items && order.items.length > 0 && (
                      <div className="mb-4">
                        <div className="space-y-3">
                          {order.items.map((item, itemIndex) => (
                            <div
                              key={itemIndex}
                              className="flex items-start space-x-4 py-3"
                            >
                              <ProductImage
                                productId={item.product_id}
                                alt={item.combo || item.product_name}
                                // className="w-32 h-32 object-cover border border-gray-200 rounded-lg"
                                className="w-24 h-24 sm:w-32 sm:h-32 object-cover border border-gray-200 rounded-lg mx-auto sm:mx-0"
                              />
                              <div className="flex-grow min-w-0">
                                {/* <h5 className="font-bold text-gray-900 text-lg leading-tight mb-2"> */}
                                {/* <h5
                                  className=" font-bold 
                                        text-gray-900 
                                        text-sm sm:text-lg 
                                        leading-tight 
                                        break-words 
                                        break-all 
                                        max-w-[180px] sm:max-w-none"
                                > */}
                                <h5
                                    className="font-bold 
                                      text-gray-900 
                                      text-sm sm:text-lg 
                                      leading-tight 
                                      whitespace-normal
                                      break-words
                                      max-w-[180px] sm:max-w-none"
                                  >
                                  <ProductName
                                    productId={item.product_id}
                                    fallback={
                                      item.combo ||
                                      item.product_name ||
                                      "Unknown Product"
                                    }
                                  />
                                </h5>
                                <p className="text-sm text-gray-500">
                                  Quantity: {item.quantity}
                                </p>
                              </div>
                              {/* <div className="text-right">
                                <p className="text-lg font-bold text-gray-900">
                                  ₹{Number(item.amount || 0).toFixed(2)}
                                </p>
                                <p className="text-sm text-gray-500">each</p>
                              </div> */}
                              <div className="text-center sm:text-right mt-2 sm:mt-0">
                                <p className="text-base sm:text-lg font-bold text-gray-900">
                                  ₹{Number(item.amount || 0).toFixed(2)}
                                </p>
                                <p className="text-xs sm:text-sm text-gray-500">
                                  each
                                </p>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* <div className="flex justify-between items-center pt-3 border-t border-gray-200"> */}
                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 pt-3">
                      {/* <div className="flex items-center space-x-4"> */}
                      {/* <div className="flex flex-col sm:flex-row sm:items-start gap-3 py-3">
                        <div>
                          <p className="text-sm font-medium text-gray-500">
                            Delivery Type
                          </p>
                          <p className="text-sm font-semibold text-gray-800">
                            {deliveryType}
                          </p>

                          <p className="text-sm font-medium text-gray-500 mt-2">
                            Product Amount
                          </p>
                          <p className="text-sm font-semibold text-gray-800">
                            ₹{productAmount.toFixed(2)}
                          </p>

                          {deliveryCharge > 0 && (
                            <>
                              <p className="text-sm font-medium text-gray-500 mt-2">
                                Delivery Charges
                              </p>
                              <p className="text-sm font-semibold text-gray-800">
                                ₹{deliveryCharge.toFixed(2)}
                              </p>
                            </>
                          )}

                          <p className="text-sm font-medium text-gray-500 mt-2">
                            Total Amount
                          </p>
                          <p className="text-lg font-bold text-gray-900">
                            ₹{totalAmount.toFixed(2)}
                          </p>
                        </div>
                      </div> */}
<div className="pt-3 space-y-2">
  {/* Row 1 */}
  <div className="flex flex-wrap justify-between gap-4">
    <div>
      <p className="text-sm text-gray-500">Delivery Type</p>
      <p className="text-sm font-semibold text-gray-800">
        {deliveryType}
      </p>
    </div>

    <div className="text-right">
      <p className="text-sm text-gray-500">Product Amount</p>
      <p className="text-sm font-semibold text-gray-800">
        ₹{productAmount.toFixed(2)}
      </p>
    </div>

    {deliveryCharge > 0 ? (
      <div className="text-right">
        <p className="text-sm text-gray-500">Delivery Charges</p>
        <p className="text-sm font-semibold text-gray-800">
          ₹{deliveryCharge.toFixed(2)}
        </p>
      </div>
    ) : null}
  </div>

  {/* Row 2 */}
  <div className="border-t pt-2">
    <p className="text-sm text-gray-500">Total Amount</p>
    <p className="text-lg font-bold text-gray-900">
      ₹{totalAmount.toFixed(2)}
    </p>
  </div>
</div>
                      <div className="flex items-center space-x-4">
                        {/* Share Button (CENTER) */}
                        {/* {(order.status === "Shipped" || order.status === "Delivered") && ( */}
                        <button
                          // onClick={() => handleShareOrder(order)}
                          onClick={() => setShareOrder(order)}
                          className="inline-flex items-center px-4 py-2 bg-white text-gray-700 text-sm font-medium rounded border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200"
                        >
                          <FiShare2 className="mr-2 text-lg" />
                          Share
                        </button>
                        {/*  )} */}
                        <StatusBadge status={order.status} />
                      </div>
                    </div>
                  </div>

                  {/* Action Buttons - Amazon Style */}
                  <div className="px-4 py-3 bg-gray-50 border-t border-gray-200 flex flex-wrap gap-2 justify-end">
                    {/* Cancel Button */}
                    {order.status !== "Cancelled" &&
                      order.status !== "Shipped" &&
                      order.status !== "Delivered" && (
                        <button
                          onClick={() => openCancelModal(order.order_id)}
                          className="inline-flex items-center px-3 py-1.5 bg-white text-gray-700 text-sm font-medium rounded border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 transition-all duration-200"
                        >
                          Cancel Order
                        </button>
                      )}

                    {/* Return Button */}
                    {order.status === "Delivered" && (
                      <button
                        onClick={() => openReturnModal(order.order_id)}
                        className="inline-flex items-center px-3 py-1.5 bg-white text-gray-700 text-sm font-medium rounded border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 transition-all duration-200"
                      >
                        Return Order
                      </button>
                    )}

                    {/* Track Order Button */}
                    {/* CHECKOUT (ONLY FOR PAYMENT PENDING) */}
                    {/* {(order.status === "Pending" || order.status === "Processing") && (
  <button
    onClick={() =>
      navigate(`/checkout/${order.order_id}`)
    }
    className="inline-flex items-center px-4 py-2 bg-green-600 text-white text-sm font-semibold rounded hover:bg-green-700 transition"
  >
    Proceed to Checkout
  </button>
)} */}
                    {(order.status === "Pending" ||
                      order.status === "Processing") && (
                      <button
                        onClick={() =>
                          navigate(`/checkout/order/${order.order_id}`)
                        }
                        className="inline-flex items-center px-3 py-1.5 bg-green-500 text-white text-sm font-medium rounded hover:bg-green-600"
                      >
                        Proceed to Pay
                      </button>
                    )}

                    {/* TRACK ORDER (ONLY AFTER PAYMENT) */}
                    {order.status !== "Pending" &&
                      order.status !== "Processing" && (
                        <button
                          onClick={() =>
                            navigate(`/order-tracking/${order.order_id}`)
                          }
                          className="inline-flex items-center px-3 py-1.5 bg-blue-500 text-white text-sm font-medium rounded hover:bg-blue-600"
                        >
                          Track this order
                        </button>
                      )}

                    {/* BUY AGAIN (ONLY DELIVERED) */}
                    {order.status === "Delivered" &&
                      order.items?.[0]?.product_id && (
                        <button
                          onClick={() =>
                            navigate(`/product/${order.items[0].product_id}`)
                          }
                          className="inline-flex items-center px-3 py-1.5 bg-orange-500 text-white text-sm font-medium rounded hover:bg-orange-600"
                        >
                          Buy Again
                        </button>
                      )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      {/* SHARE POPUP — ADD HERE */}
      {shareOrder && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
          <div className="bg-white rounded-lg w-80 shadow-xl">
            {/* Header */}
            <div className="px-4 py-3 border-b font-semibold text-gray-800">
              Share Order
            </div>

            {/* Share with Us */}
            <div className="px-4 py-3 border-b">
              <p className="text-sm font-medium text-gray-600 mb-2">
                Share with us
              </p>

              {/* WhatsApp */}
              <a
                href={`https://wa.me/917904168568?text=${encodeURIComponent(
                  getShareText(shareOrder),
                )}`}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 px-3 py-2 rounded hover:bg-gray-100"
              >
                <FaWhatsapp className="text-green-600 text-lg" />
                WhatsApp
              </a>

              {/* Email 1 */}
              <a
                href={`mailto:malarsbakers@gmail.com?subject=Order%20Details&body=${encodeURIComponent(
                  getShareText(shareOrder),
                )}`}
                className="flex items-center gap-2 px-3 py-2 rounded hover:bg-gray-100"
              >
                <FiMail className="text-blue-600 text-lg" />
                orders@malarsbakers.com
              </a>

              {/* Email 2 */}
              {/* <a
                href={`mailto:support@malarsbakers.com?subject=Order%20Details&body=${encodeURIComponent(
                  getShareText(shareOrder)
                )}`}
                className="flex items-center gap-2 px-3 py-2 rounded hover:bg-gray-100"
              >
                <FiMail className="text-blue-600 text-lg" />
                support@malarsbakers.com
              </a> */}
            </div>

            {/* Share with Others */}
            <div className="px-4 py-3">
              <button
                onClick={() => {
                  handleShareOrder(shareOrder);
                  setShareOrder(null);
                }}
                className="w-full flex items-center justify-center gap-2 px-3 py-2 border  rounded bg-[#c97c5d] hover:bg-orange-300 text-black"
              >
                <FiShare2 />
                Share with others
              </button>
            </div>

            {/* Close */}
            <button
              onClick={() => setShareOrder(null)}
              className="w-full py-2 text-sm text-black  bg-[#c97c5d]  hover:bg-orange-300 rounded-b-lg"
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* Cancel Modal */}
      {cancelModalOpen && (
        <CancelOrderModal
          onClose={() => setCancelModalOpen(false)}
          onConfirm={handleCancelOrder}
        />
      )}

      {/* Return Modal */}
      {returnModalOpen && (
        <ReturnOrderModal
          onClose={() => setReturnModalOpen(false)}
          onConfirm={handleReturnOrder}
        />
      )}

      {/* Cancel Modal */}
      {cancelModalOpen && (
        <CancelOrderModal
          onClose={() => setCancelModalOpen(false)}
          onConfirm={handleCancelOrder}
        />
      )}

      {/* Return Modal */}
      {returnModalOpen && (
        <ReturnOrderModal
          onClose={() => setReturnModalOpen(false)}
          onConfirm={handleReturnOrder}
        />
      )}
    </div>
  );
};

export default MyOrders;
